import { Row, Col, FormGroup, Label, Input } from "reactstrap";

const indiceOptions = {
  MSI: ["NDVI", "NDMI", "NDRE", "NDWI", "CIG", "CIRedEdge"],
  Weather: [
    "Min Temperature",
    "Max Temperature",
    "Precipitation",
    "Wind Speed",
    "Relative Humidity",
    "Solar Radiation",
  ],
  SAR: ["RVI"],
};

const ProjectAnalyticsSection = ({selectedTypes,setSelectedTypes, typeAliases, setTypeAliases,
    indexSelection, setIndexSelection, indexAliases, setIndexAliases}) => {
//   const [selectedTypes, setSelectedTypes] = useState({});
//   const [typeAliases, setTypeAliases] = useState({});
//   const [indexSelection, setIndexSelection] = useState({});
//   const [indexAliases, setIndexAliases] = useState({});

  const handleMainTypeChange = (type) => {
    const updated = !selectedTypes[type];
    setSelectedTypes((prev) => ({ ...prev, [type]: updated }));
    if (updated) {
      setTypeAliases((prev) => ({ ...prev, [type]: type }));
    } else {
      const updatedSelection = { ...indexSelection };
      const updatedAlias = { ...indexAliases };
      delete updatedSelection[type];
      delete updatedAlias[type];
      setIndexSelection(updatedSelection);
      setIndexAliases(updatedAlias);
    }
  };

  const handleTypeAliasChange = (type, value) => {
    setTypeAliases((prev) => ({ ...prev, [type]: value }));
  };

  const handleIndexCheckboxChange = (type, index) => {
    const selected = indexSelection[type] || [];
    const updated = selected.includes(index)
      ? selected.filter((i) => i !== index)
      : [...selected, index];

    setIndexSelection((prev) => ({ ...prev, [type]: updated }));
    if (!indexAliases[type]?.[index]) {
      setIndexAliases((prev) => ({
        ...prev,
        [type]: {
          ...(prev[type] || {}),
          [index]: index,
        },
      }));
    }
  };

  const handleIndexAliasChange = (type, index, value) => {
    setIndexAliases((prev) => ({
      ...prev,
      [type]: {
        ...(prev[type] || {}),
        [index]: value,
      },
    }));
  };

//   const getAnalyticsPayload = () => {
//     const payload = [];

//     Object.keys(selectedTypes).forEach((type) => {
//       if (selectedTypes[type]) {
//         const indices = (indexSelection[type] || []).map((index) => ({
//           name: index,
//           alias: indexAliases[type]?.[index] || index,
//         }));

//         payload.push({
//           type,
//           alias: typeAliases[type],
//           indices,
//         });
//       }
//     });
//     console.log("payload",payload)

//     return payload;
//   };

  return (
    <div className="p-3 border rounded shadow-sm mt-3">
      <h5 className="text-primary mb-1">Analytics Configuration</h5>
      <Row className="">
        {Object.keys(indiceOptions).map((type) => (
          <Col key={type} xs="12" sm="6" md="4" lg="3" className="mb-2">
            <FormGroup className="d-flex align-items-center">
                <Input
                  type="checkbox"
                  checked={!!selectedTypes[type]}
                  onChange={() => handleMainTypeChange(type)}
                />
                <Label  className="d-flex align-items-center">
                <span className="ms-2 fw-bold mt-3">{type}</span>
              </Label>
            </FormGroup>
          </Col>
        ))}
      </Row>

      {Object.entries(selectedTypes).map(
        ([type, isSelected]) =>
          isSelected && (
            <div key={type} className="mb-4 p-3 border rounded">
              <Row className="mb-3">
                <Col md="6" lg="4">
                  <Label className="fw-semibold">Alias for {type}</Label>
                  <Input
                    type="text"
                    value={typeAliases[type]}
                    onChange={(e) => handleTypeAliasChange(type, e.target.value)}
                    style={{borderRadius:"7px"}}
                  />
                </Col>
              </Row>

              <Label className="fw-semibold">Select Indices & Aliases</Label>
              <Row>
                {indiceOptions[type].map((index, i) => (
                  <Col xs="12" md="6" lg="4" key={index} className="mb-3">
                    <FormGroup  className="d-flex align-items-center">
                      <Input
                        type="checkbox"
                        checked={indexSelection[type]?.includes(index) || false}
                        onChange={() => handleIndexCheckboxChange(type, index)}
                      />
                      <span className="ms-2 me-2">{index}</span>
                      {indexSelection[type]?.includes(index) && (
                        <Input
                          type="text"
                          placeholder={`Alias for ${index}`}
                          value={indexAliases[type]?.[index] || ""}
                          onChange={(e) =>
                            handleIndexAliasChange(type, index, e.target.value)
                          }
                          className="ms-2"
                          style={{borderRadius:"7px"}}
                        />
                      )}
                    </FormGroup>
                  </Col>
                ))}
              </Row>
            </div>
          )
      )}

    </div>
  );
};

export default ProjectAnalyticsSection;
